export const state = {
  __blocks: [],
  __RelatedProduct: [],
};
